import {
  IconCircleCheck,
  IconCircleDashed,
  IconCircleOff,
} from '@tabler/icons-react'

import { SortOption } from '@/components/layout-components/CorePageListViewSort'

import { InductionStatus, InductionType, SortOrder } from 'types/api.graphql'

export const INDUCTION_STATUSES = {
  [InductionStatus.WaitingReview]: {
    label: 'Waiting review',
    icon: <IconCircleDashed size={16} />,
    variant: 'warning' as const,
  },
  [InductionStatus.Reviewed]: {
    label: 'Reviewed',
    icon: <IconCircleCheck size={16} />,
    variant: 'success' as const,
  },
  [InductionStatus.ChangesRequested]: {
    label: 'Changes requested',
    icon: <IconCircleOff size={16} />,
    variant: 'danger' as const,
  },
}

export const LOCALISE_INDUCTION_TYPE: Record<InductionType, string> = {
  [InductionType.BuilderInduction]: 'worker:profile.companyInduction',
  [InductionType.ProjectInduction]: 'worker:profile.siteInduction',
}

export const INDUCTION_SORT: SortOption[] = [
  {
    label: 'Date',
    direction: SortOrder.Desc,
    key: 'createdAt',
    description: 'newest',
    default: true,
  },
  {
    label: 'Date',
    direction: SortOrder.Asc,
    key: 'createdAt',
    description: 'oldest',
  },
  {
    label: 'Worker name',
    direction: SortOrder.Asc,
    key: 'workerName',
    description: 'A-Z',
  },
  {
    label: 'Worker name',
    direction: SortOrder.Desc,
    key: 'workerName',
    description: 'Z-A',
  },
  {
    label: 'Company',
    direction: SortOrder.Asc,
    key: 'subcontractorName',
    description: 'A-Z',
  },
  {
    label: 'Company',
    direction: SortOrder.Desc,
    key: 'subcontractorName',
    description: 'Z-A',
  },
  {
    label: 'Status',
    direction: SortOrder.Asc,
    key: 'status',
    description: 'A-Z',
  },
  {
    label: 'Status',
    direction: SortOrder.Desc,
    key: 'status',
    description: 'Z-A',
  },
]
